import { useCallback, useState } from 'react'
import AuthService from '../../services/auth-service'
import { toast } from 'react-toastify'

const useChangePassword = setIsChangePasswordModalOpen => {
  const [isLoading, setIsLoading] = useState(false)
  const [inputs, setInputs] = useState({
    currentPassword: '',
    password: '',
    confirmPassword: '',
  })
  const [errors, setErrors] = useState({
    currentPasswordError: false,
    passwordError: false,
    confirmPasswordError: false,
    error: false,
    textError: '',
  })

  const handleChange = useCallback(
    e => {
      setInputs({
        ...inputs,
        [e.target.name]: e.target.value,
      })
    },
    [inputs],
  )

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()

      let errors = {}
      if (inputs.currentPassword.trim().length < 8) {
        errors = { ...errors, currentPasswordError: true }
      }

      if (inputs.confirmPassword.trim() !== inputs.password.trim()) {
        errors = { ...errors, confirmPasswordError: true }
      }

      setErrors(errors)
      if (Object.keys(errors).length > 0) {
        return
      }
      setIsLoading(true)
      AuthService.changePassword({
        old_password: inputs.currentPassword,
        new_password: inputs.password,
      })
        .then(() => {
          setInputs({
            currentPassword: '',
            password: '',
            confirmPassword: '',
          })
          toast.success('Parolă schimbată cu succes', {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: true,
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            className: 'text-sm',
          })

          setErrors({
            currentPasswordError: false,
            passwordError: false,
            confirmPasswordError: false,
            error: false,
            textError: '',
          })
        })
        .catch(res => {
          const response = res.response
          const status = response.status
          if (status === 400) {
            const responseErrors = response.data.errors

            let errors = {}
            if ('old_password' in responseErrors) {
              errors = { ...errors, currentPasswordError: true }
            }
            if ('new_password' in responseErrors) {
              errors = { ...errors, passwordError: true }
            }
            setErrors(errors)
          }
        })
        .finally(() => {
          setIsLoading(false)
          if (setIsChangePasswordModalOpen) {
            setIsChangePasswordModalOpen(false)
          }
        })
    },
    [inputs, setIsChangePasswordModalOpen],
  )
  return { handleSubmit, inputs, errors, handleChange, isLoading }
}

export default useChangePassword
